<template>
  <div v-show="show" class="articlePreview-container">
    <div class="articlePreview-content">
      <i @click="close" class="close"></i>
      <div class="title">
        <p :title="info.title">{{info.title}}</p>
        <div class="info">
          <div class="left">
            <span>渠道：{{info.type}}</span>
            <span>来源：{{info.client_name}}</span>
            <span>作者：{{info.author}}</span>
            <span>发布时间: {{info.raw_add_time}}</span>
          </div>
          <div v-if="info.url" @click="navigate(info.url)" class="right">
            <i></i>
            <span>查看原文</span>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="left">
          <div v-if="info.info" class="info">{{info.info}}</div>
          <div v-html="info.content" class="word"></div>
        </div>
        <div class="right">
          <ul>
            <li v-if="info.people && info.people.length > 0">
              <div class="title">人物标签：</div>
              <ul>
                <li v-for="(item, index) in info.people" :key="index">{{item}}</li>
              </ul>
            </li>
            <li v-if="info.org && info.org.length > 0">
              <div class="title">机构标签：</div>
              <ul>
                <li v-for="(item, index) in info.org" :key="index">{{item}}</li>
              </ul>
            </li>
            <li v-if="info.loc && info.loc.length > 0">
              <div class="title">地点标签：</div>
              <ul>
                <li v-for="(item, index) in info.loc" :key="index">{{item}}</li>
              </ul>
            </li>
            <li v-if="info.other && info.other.length > 0">
              <div class="title">其他：</div>
              <ul>
                <li v-for="(item, index) in info.other" :key="index">{{item}}</li>
              </ul>
            </li>
            <li v-if="info.emotion">
              <div class="title">情感：</div>
              <ul>
                <li :class="{high: info.emotion == '正面', normal: info.emotion == '中性', low: info.emotion == '负面'}">{{info.emotion}}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";

export default {
  data() {
    return {
      show: false,
      info: {

      },
      callback: null
    }
  },
  methods: {
    navigate(url) {
      common.jumpOut(url)
    },
    open(config, callback) {
      this.info = config;
      this.callback = callback;
      this.show = true

      this.$nextTick(() => {
        let articlePreviewContainerDom = document.getElementsByClassName("articlePreview-container")[0];
        let imgDom = articlePreviewContainerDom.getElementsByTagName("video");
        for (let index = 0; index < imgDom.length; index++) {
          const element = imgDom[index];
          let newDiv = document.createElement("div");
          let materialDom = `
            <div data-index="${index}" class="toMaterial">
              <i></i>
              <span>我的素材</span>
            </div>
          `
          newDiv.className = 'videoContainer'
          newDiv.innerHTML = materialDom
          newDiv.appendChild(element.cloneNode(true));
          element.parentNode.replaceChild(newDiv, element);
        }

        let toMaterialDom = document.getElementsByClassName('toMaterial')
        console.log(toMaterialDom)
        for (let index = 0; index < toMaterialDom.length; index++) {
          toMaterialDom[index].addEventListener('click', () => {
            let info = {
              url: imgDom[index].src,
              title: this.info.title
            }

            common.myFetch(apis.browserdownload, info).then((res) => {
              if(res){
                this.$toast(res)
              }
              // console.log(res)
            })
          })
        }
      })
    },
    close() {
      this.show = false
    }
  }
}
</script>

<style scoped lang="less">
  .articlePreview-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: rgba(50, 59, 75, 0.3); 
    backdrop-filter: blur(1.6px);

    .articlePreview-content {
      display: flex;
      flex-direction: column;
      position: relative;
      width: 920px;
      height: 560px;
      background: #FFFFFF;
      border-radius: 2px;
      padding: 40px 40px 9px;
      box-sizing: border-box;

      .close {
        position: absolute;
        top: 20px;
        right: 20px;
        display: block;
        width: 20px;
        height: 20px;
        background: url('./assets/delIcon.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        user-select: none;
        cursor: pointer;
      }

      &>.title {
        width: 100%;
        padding-bottom: 10px;
        border-bottom: 1px solid #DCDCDC;
        box-sizing: border-box;

        &>p {
          font-size: 20px;
          line-height: 30px;
          color: #050F0F;
          font-weight: bold;
          margin-bottom: 10px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .info {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;

          .left {
            display: flex;
            flex-direction: row;
            align-items: center;

            span {
              font-size: 12px;
              line-height: 17px;
              color: #829191;
              margin-right: 24px;

              &:nth-last-of-type(1) {
                margin-right: 0;
              }
            }
          }

          .right {
            display: flex;
            flex-direction: row;
            align-items: center;

            i {
              display: block;
              width: 20px;
              height: 20px;
              background: url('./assets/link.png') no-repeat;
              background-position:  center center;
              background-size: 100% 100%;
              margin-right: 4px;
            }

            span {
              font-size: 14px;
              line-height: 20px;
              color: #41B48C;
              font-weight: bold;
            }
          }
        }
      }

      .content {
        display: flex;
        flex-direction: row;
        width: 100%;
        flex: 1;

        .left {
          width: 510px;
          height: 440px;
          padding-right: 14px;
          border-right: 1px solid #DCDCDC;
          box-sizing: border-box;
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 6px;
          }
          &::-webkit-scrollbar-thumb {
            background: rgba(185,195,195,0.5);
            border-radius: 4px;
          }

          .info {
            width: 100%;   
            background: #F9F9F9;
            font-size: 14px;
            line-height: 21px;
            color: #829191;
            font-weight: 500;
            padding: 14px;
            margin-top: 13px;
            margin-bottom: 14px;
            box-sizing: border-box;
            word-break: break-all;
          }

          .word {
            font-size: 16px;
            line-height: 28px;
            color: #050F0F;
            padding-top: 10px;
            box-sizing: border-box;

            img {
              max-width: 100%;
              height: auto;
            }
          }
        }

        .right {
          display: flex;
          flex-direction: column;
          flex: 1;
          height: 440px;
          padding: 13px 16px;
          box-sizing: border-box;
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 6px;
          }
          &::-webkit-scrollbar-thumb {
            background: rgba(185,195,195,0.5);
            border-radius: 4px;
          }

          ul {
            display: flex;
            flex-direction: column;

            li {
              display: flex;
              flex-direction: column;
              margin-bottom: 14px;

              .title {
                font-size: 12px;
                line-height: 17px;
                color: #829191;
                font-weight: 500;
                margin-bottom: 10px;
              }

              ul {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;

                li {
                  font-size: 13px;
                  color: #323B4B;
                  padding: 0 14px;
                  height: 24px;
                  line-height: 24px;
                  box-sizing: border-box;
                  background: rgba(185,195,195,0.2);
                  border-radius: 4px;
                  margin: 0 10px 10px 0;

                  &.high {
                      background: rgba(113, 158, 248, 0.1);
                      border: 1px solid #719EF8;
                      color: #719EF8;
                      box-sizing: border-box;
                  }

                  &.normal {
                      background: rgba(113,220,177,0.1000);
                      border: 1px solid #71DCB1;
                      color: #71DCB1;
                      box-sizing: border-box;
                  }

                  &.low {
                      background: rgba(233,124,99,0.1000);
                      border: 1px solid #E97C63;
                      color: #E97C63;
                      box-sizing: border-box;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>

<style lang="less">
  .articlePreview-container {
    .word {
       img {
         max-width: 100%;
         height: auto;
       }
    }

    video {
      max-width: 100%;
    }

    .videoContainer {
      position: relative;

      .toMaterial {
        position: absolute;
        top: 14px;
        left: 14px;
        z-index: 99;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 104px;
          height: 30px;
          background: rgba(65, 180, 140, 0.7);
          border-radius: 15px;
          user-select: none;
          cursor: pointer;

        i {
            display: block;
            width: 16px;
            height: 16px;
            background: url('./assets/send.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-right: 6px;
        }

        span {
            font-size: 14px;
            line-height: 20px;
            color: #FFFFFF;
            font-weight: 800;
        }
      }
    }
  }
</style>